var address = {
	data () {
		return {
			listComunas: [],
			searchingComunas: false,
			objectAddress: {
				text: '',
				street: '',
				number: '',
				extra: '',
				comuna_id: 0,
				transport_id: 0,
				longitude: 0,
				latitude: 0,
				postal_code: '',
				send: 1
			},
			listTrasports: [
				{ id: 1, name: 'Retira en ACES', color: 'primary', region_id: 13, street: 'Santa Elena', number: '1038', comuna_id: 279 },
				{ id: 2, name: 'Starken', color: 'success', region_id: null },
				{ id: 3, name: 'Correos de Chile', color: 'danger', region_id: null },
				{ id: 6, name: 'Retira en MSMCH', color: 'info', region_id: 13, street: 'Fernando Rioja', number: '173', comuna_id: 287 },
			]
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		clearObjectAddress() {
			this.objectAddress.street = ''
			this.objectAddress.number = ''
			this.objectAddress.extra = ''
			this.objectAddress.comuna_id = 0
			this.objectAddress.transport_id = 0
			this.objectAddress.longitude = 0
			this.objectAddress.latitude = 0
			this.objectAddress.postal_code = ''
			this.objectAddress.send = 1
		},
		getAllComunas() {
			this.searchingComunas = true
			let url = this.getApiBackend + 'comunas'
			this.axiosLocal('POST', url, 'getAllComunasResult')
		},
		getAllComunasResult(response) {
			this.searchingComunas = false
			if(response.data.success == true) {
				this.listComunas = response.data.data
			}
		}
	},
}

export default address;